import { z } from 'zod';

const LETTERS_ONLY_REGEX = /^[a-zA-Zа-яА-ЯёЁ\s]+$/;

const senderFullNameSchema = z
    .string()
    .trim()
    .superRefine((value, ctx) => {
        if (value.length === 0 || !LETTERS_ONLY_REGEX.test(value)) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Введите только буквы' });
            return;
        }
        const words = value.split(/\s+/).filter(Boolean);
        if (words.length < 2) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Введите фамилию и имя полностью' });
            return;
        }
        if (words.join('').length < 5) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Введите минимум 5 символов' });
            return;
        }
    });

export const callbackRequestSchema = z.object({
    senderFullName: senderFullNameSchema,
    shopCity: z.string().trim().min(3, 'Укажите название города полностью'),
    comment: z.string().trim().min(10, 'Опишите суть обращения подробнее').max(3000),
});

export type CallbackRequestFormValues = z.infer<typeof callbackRequestSchema>;
